import Manage from "../../types/manage";
import {DS_GROUP_LOADING, DS_GROUP_SUCCESS, DS_GROUP_ERRORS, DS_GROUP_UPDATE} from "../actions/manageSpecGroups.actions";

export interface ManageSpecGroupSettings {
  items?: Array<Manage.Spec.Group>;
  page?: number;
  pageSize?: number;
  totalItems?: number;
  hasMore?: boolean;
  errors?: any;
  loading?: boolean;
}

const initState: ManageSpecGroupSettings = {
  errors: null, hasMore: false, items: [], loading: false, page: 0, pageSize: 50, totalItems: 0
}

export const manageSpecGroupsReducer = (state = initState, action): ManageSpecGroupSettings => {
  switch (action.type) {
    case DS_GROUP_LOADING:
      return {
        ...state,
        items: action.loading && action.reset ? [] : state.items,
        loading: action.loading,
      }
    case DS_GROUP_ERRORS:
      return {
        ...state,
        errors: action.errors,
      }
    case DS_GROUP_SUCCESS:
      return {
        ...state,
        items: action.page > 0 ? state.items.concat(action.items) : action.items,
        page: action.page,
        pageSize: action.pageSize,
        totalItems: action.totalItems,
        hasMore: (action.page + 1) * action.pageSize + action.pageSize < action.totalItems && action.totalItems > 0,
        errors: null,
      }
    case DS_GROUP_UPDATE:
      const index = state.items.findIndex(value =>  value.id === action.item.id)
      if(~index){
        state.items[index] = action.item
      }else{
        state.items.unshift(action.item)
      }
      console.log('state::', state)
      return {
        ...state,
        items: [...state.items],
      }
    default:
      return state
  }
}
